import { GANTT_ROW_HEIGHT_MAX, GANTT_ROW_HEIGHT_MIN } from "../constants.js";

let uiState = null;
let scheduleRender = () => {};
let ganttPinchState = null;

export function configureGanttPinch(deps) {
  uiState = deps.uiState || uiState;
  scheduleRender = deps.scheduleRender || scheduleRender;
}

export function handleGanttPinchStart(event) {
  if (event.touches.length !== 2) return;
  const scroller = event.target.closest?.("[data-mobile-gantt-scroll]");
  if (!scroller) return;
  const [a, b] = event.touches;
  const dist = Math.hypot(b.clientX - a.clientX, b.clientY - a.clientY);
  ganttPinchState = {
    startDist: dist,
    startRowHeight: uiState?.ganttRowHeight || 44,
  };
}

export function handleGanttPinchMove(event) {
  if (!ganttPinchState || event.touches.length !== 2 || !uiState) return;
  const [a, b] = event.touches;
  const dist = Math.hypot(b.clientX - a.clientX, b.clientY - a.clientY);
  const ratio = dist / ganttPinchState.startDist;
  const next = Math.round(ganttPinchState.startRowHeight * ratio);
  const clamped = Math.max(GANTT_ROW_HEIGHT_MIN, Math.min(GANTT_ROW_HEIGHT_MAX, next));
  if (clamped !== uiState.ganttRowHeight) {
    uiState.ganttRowHeight = clamped;
    event.preventDefault();
    scheduleRender();
  }
}

export function handleGanttPinchEnd() {
  ganttPinchState = null;
}

export function resetGanttPinch() {
  ganttPinchState = null;
}
